module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "ack"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Acknowledgments")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("I would like to acknowledge my agent, Karen Solem, who never says, “You want to write WHAT?”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('span', [_vm._v("And a huge hug to my new editor, Micki Nuding, who was also my old editor from a long time ago. Micki, you were right! We’re working together again! WOOHOO!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dd37a65","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416538318_ack.vue
// module id = 69
// module chunks = 0